module.exports = __webpack_public_path__ + "img/材料力学1_5_2.c197f4f5.jpg";